module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "prologue"
    }
  }, [_c('h1', [_vm._v("Prologue")]), _vm._v(" "), _c('p', [_vm._v("Everything written in this book was done while in the midst of a manic episode with psychotic features. My formal diagnosis is schizoaffective disorder, bipolar type as well as ADHD.")]), _vm._v(" "), _c('p', [_vm._v("I can’t define this book as fiction or non-fiction. It’s merely my thoughts and a form of processing.")]), _vm._v(" "), _c('p', [_vm._v("Please take what you will from it and leave what doesn’t resonate.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("I am only human.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec7193a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0